import React from 'react';
import Meta from '../components/Meta';
import SampleDetails from '../components/SampleDetails';

function SampleDetailsPage() {
  return (
    <>
      <Meta title="Sample Details" />
      <SampleDetails />
    </>
  );
}

export default SampleDetailsPage;
